import { ReactNode } from "react";

import { ButtonGroup } from "@/components/_atoms/button-group";
import { Separator } from "@/components/_atoms/separator";
import { UserFavoriteButton } from "@/domain/user/components/user-favorite-button";

interface ListHeaderBarProps {
  title: ReactNode;
  pageName: string;
  children?: ReactNode;
  actions?: ReactNode;
}

export const ListHeaderBar = ({ title, pageName, children, actions }: ListHeaderBarProps) => {
  return (
    <div className="flex w-full flex-row items-center justify-between gap-2">
      <div className="flex flex-row items-center gap-2">
        {title}
        <UserFavoriteButton pageName={pageName} />
        {children ? (
          <>
            <Separator orientation="vertical" className="mx-1 h-4" />
            <ButtonGroup>{children}</ButtonGroup>
          </>
        ) : null}
      </div>
      {actions ? <div className="flex flex-row items-center gap-2">{actions}</div> : null}
    </div>
  );
};
